<header>
  <div class="page-title">
    <div class="top">
      <h1>{{ title$ | async }}</h1>
      <fa-icon [icon]="['fas', 'circle-info']" size="lg"></fa-icon>
    </div>
    @if (showAdditionalTitleInfo()) {
      <div class="bottom">
        @if (data$ | async; as data) {
          @if (data['restoreData']) {
            <ng-container
              *ngTemplateOutlet="
                websiteRestoreDetails;
                context: { $implicit: data['restoreData']['restoreTask'] }
              "
            ></ng-container>
          } @else if (data['groupData']) {
            <ng-container
              *ngTemplateOutlet="groupDetails; context: { $implicit: data['groupData'] }"
            ></ng-container>
          } @else if (data['group']) {
            <ng-container
              *ngTemplateOutlet="groupUsageDetails; context: { $implicit: data['group'] }"
            ></ng-container>
          } @else {
            <ng-container
              *ngTemplateOutlet="websiteDetails; context: { $implicit: data['websiteData'] }"
            ></ng-container>
          }
        }
      </div>
    }
  </div>

  <div class="search-wrapper">
    <div class="search-field">
      <fa-icon [icon]="['fas', 'magnifying-glass']" size="lg"></fa-icon>
      <input placeholder="Search..." />
    </div>
  </div>

  <button
    class="bell"
    [class.active]="isNotificationsOpen"
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    (click)="openCloseNotifications()"
  >
    <div matBadge="1" matBadgeSize="small">
      <fa-icon [icon]="['far', 'bell']" size="xl"></fa-icon>
    </div>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isNotificationsOpen"
    [cdkConnectedOverlayOffsetY]="8"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayMinWidth]="320"
    (detach)="isNotificationsOpen = false"
    (overlayOutsideClick)="isNotificationsOpen = false"
  >
    <div class="notifications">
      @if (notifications$ | async; as notifications) {
        <app-notifications [notifications]="notifications"></app-notifications>
      } @else if (loading) {
        <span>Loading...</span>
      } @else {
        <span>No new notifications.</span>
      }
    </div>
  </ng-template>

  <div
    class="user-profile"
    [class.expanded]="isUserMenuExpanded"
    (appClickOutside)="isUserMenuExpanded = false"
  >
    <div class="user" (click)="expandMenu()" role="presentation">
      <div class="icon-bg">
        <fa-icon [icon]="['far', 'user']" size="lg"></fa-icon>
      </div>
      <div class="details">
        <span class="name">{{ (userName$ | async) || 'Unknown' }}</span>
        <span class="role">{{ (userRole$ | async | titlecase) || 'Unknown' }}</span>
      </div>
      <fa-icon [icon]="['fas', isUserMenuExpanded ? 'caret-up' : 'caret-down']" size="xl"></fa-icon>
    </div>
    <div class="menu">
      <button matButton="tonal" [routerLink]="['/user-profile']" (click)="closeUserMenu()">
        My profile
      </button>
      <p>
        <span>Dark theme</span>
        <mat-slide-toggle></mat-slide-toggle>
      </p>
      <button matButton="tonal" (click)="logout()">Logout</button>
    </div>
  </div>
</header>

<ng-template #websiteDetails let-data
  ><app-status-label [status]="data.website.status" size="small"></app-status-label> •
  <span>{{ SITE_TYPES[data.website.type] }}</span> •
  <span>{{ data.server.hostname }}</span></ng-template
>

<ng-template #websiteRestoreDetails let-data
  ><app-status-label [status]="toStatus(data.status)" size="small"></app-status-label> •
  <span>ID: {{ data.id }}</span></ng-template
>

<ng-template #groupDetails let-data>
  <app-status-label [status]="data.websiteGroup.mainWebsite.status" size="small"></app-status-label>
  • <span>{{ data.hostingPlan.name }}</span> • <span>{{ data.server.hostname }}</span> •
  <span
    >Main domain
    <a [href]="`/overview/${data.websiteGroup.mainWebsite.id}`" class="link"
      >{{ data.websiteGroup.mainWebsite.domain }}
      <fa-icon [icon]="['fas', 'arrow-up-right-from-square']" size="sm"></fa-icon
    ></a>
  </span>
</ng-template>

<ng-template #groupUsageDetails let-data>
  <span>{{ data.plan.name }}</span>
</ng-template>
